export default __webpack_public_path__ + "static/media/portfoliopage.6aec63b0.png";